export const UPDATE_ROOM_ERROR = "UPDATE_ROOM_ERROR";
export const UPDATE_ROOM_SALESFORCE_ERROR = "UPDATE_ROOM_SALESFORCE_ERROR";
export const SWAP_ROOM_ERROR = "SWAP_ROOM_ERROR";
export const ROOM_NOT_FOUND_ERROR = "ROOM_NOT_FOUND_ERROR";
